import { createFileRoute } from '@tanstack/react-router';
import DossierView from '../../features/dossiers/dossier/view/view';
import {
  createObjectPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/$dossierId')({
  component: DossierView,
  beforeLoad: createObjectPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'READ'),
    (params) => params.dossierId,
  ),
});

export const ViewDossierRoute = Route;
